export default __webpack_public_path__ + "static/look-3-alt-mobile-762f813be97f8fb9a3daf5367c819731.png";